import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-jc-around p-ai-center"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-danger" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "p-ml-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-danger" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.pickupPriority || _ctx.dropoffPriority)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.pickupPriority)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("span", null, [
                _hoisted_3,
                _createVNode(_component_DateFormatted, {
                  date: _ctx.pickupDateTime,
                  format: "HH:mm"
                }, null, 8, ["date"])
              ], 512), [
                [
                  _directive_tooltip,
                  'Ritiro urgente',
                  void 0,
                  { bottom: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.dropoffPriority)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createElementVNode("span", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_DateFormatted, {
                  date: _ctx.dropoffDateTime,
                  format: "HH:mm"
                }, null, 8, ["date"])
              ], 512), [
                [
                  _directive_tooltip,
                  'Consegna urgente',
                  void 0,
                  { bottom: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}